import { render, staticRenderFns } from "./StatusPedido.vue?vue&type=template&id=e5ebbf10&scoped=true"
import script from "./StatusPedido.vue?vue&type=script&lang=js"
export * from "./StatusPedido.vue?vue&type=script&lang=js"
import style0 from "./StatusPedido.vue?vue&type=style&index=0&id=e5ebbf10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ebbf10",
  null
  
)

export default component.exports